"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStateToProps = void 0;
var React = require("react");
var fp = require("fp-ts");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Summary_1 = require("./Summary");
var Additional_1 = require("./Additional");
var SelectedFiles_1 = require("./SelectedFiles");
var RecipientList_1 = require("./components/RecipientList");
var Types = require("types");
var userLens_1 = require("@caddigital/sok-reducers/lib/utils/userLens");
var WizardActions = require("@caddigital/sok-reducers/lib/actions/order/wizard");
var mapStateToProps = function (state) { return ({
    files: state.order.wizard.checkingFiles.files,
    values: state.order.wizard.values,
    step4: state.order.wizard.step4,
    deliveryMethods: state.order.deliveryMethods,
    finishings: state.order.finishings,
    printProviders: state.order.printProviders,
    recipients: state.order.recipients,
    addressBook: state.order.addressBook,
    user: state.auth.current.user,
    currentFrame: state.order.wizard.fileHistory.currentFrame,
    orderFilesStatus: state.order.wizard.orderFilesStatus,
    isSaving: state.order.wizard.isSaving,
    token: state.auth.current.token,
    selectedFiles: state.order.wizard.fileHistory.selectedFiles,
    history: state.order.wizard.fileHistory.history,
    historyBrowsed: state.order.wizard.fileHistory.historyBrowsed
}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    step4Toggle: function () { return dispatch(WizardActions.step4Toggle()); },
    setAdditionalInformation: function (value) {
        return dispatch(WizardActions.step4SetAdditional(value));
    },
    selectFile: function (uuids) {
        return dispatch(WizardActions.step3SelectFiles(uuids));
    },
    changeColor: function (file, color) {
        return dispatch(WizardActions.step3ChangeColor(file, color));
    },
    unselectFile: function (uuids) {
        return dispatch(WizardActions.step3UnselectFiles(uuids));
    }
}); };
//#region Types
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToPropsExtractable = Types.extractReturnType(mapDispatchToProps);
//#endregion
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, mapDispatchToProps), recompose_1.pure);
var component = enhance(function (props) {
    var orderRecipients = Object.values(props.values.orderRecipients).sort(function (a, b) { return userLens_1.getName.get(a.user).localeCompare(userLens_1.getName.get(b.user)); });
    var distributionRecipients = props.values.distributionLists &&
        props.values.distributionLists
            .sort(function (a, b) { return a.name.localeCompare(b.name); })
            .map(function (l) {
            return l.recipients
                .filter(function (r) { return !r.excluded; })
                .sort(function (a, b) {
                return userLens_1.getName.get(a.user).localeCompare(userLens_1.getName.get(b.user));
            })
                .map(function (rec) {
                return __assign(__assign({}, rec), { distributionName: l.name });
            });
        });
    var recipients = orderRecipients.concat(fp.array.flatten(distributionRecipients));
    var _a = props.currentFrame, deleted = _a.deleted, hardDeleted = _a.hardDeleted;
    return (React.createElement("div", { className: 'order-wizard-step4' },
        React.createElement("div", { className: 'disclaimer' },
            React.createElement("div", null, props.type === 'SINGLE'
                ? (0, translation_1.getLocalization)('userfront/order/step4/info')
                : (0, translation_1.getLocalization)('userfront/order/step4/info/automatic'))),
        React.createElement(Summary_1.default, __assign({}, props)),
        React.createElement(Additional_1.default, __assign({}, props)),
        React.createElement(SelectedFiles_1.default, { disableWizardFields: true, selectedLanguage: props.selectedLanguage, files: props.files.filter(function (file) {
                return deleted[file.uuid] !== true && hardDeleted[file.uuid] !== true;
            }), metadata: props.metadata, selectFile: props.selectFile, changeColor: props.changeColor, unselectFile: props.unselectFile, selectedFiles: props.selectedFiles, historyBrowsed: props.historyBrowsed, currentFrame: props.currentFrame, token: props.token, history: props.history }),
        React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/distribution/recipients')),
        React.createElement(RecipientList_1.ListContainer, __assign({}, props, { project: props.currentProject, distributionRecipients: recipients }))));
});
exports.default = component;
